import ReactPaginate from 'react-paginate'
import './pagination.scss'

type PaginationProps = {
  totalItems: number
  pageSize: number
  onPageChange: (page: number) => void
  currentPage: number
}

/**
 * Reusable pagination UI component with ellipsis pattern for large page counts.
 * Uses react-paginate for the UI rendering.
 *
 * Note: This is a pure UI component. For URL sync, use the usePaginatedState hook
 * in the parent component.
 */
export const Pagination = ({
  totalItems,
  pageSize,
  onPageChange,
  currentPage,
}: PaginationProps) => {
  const totalPages = Math.ceil(totalItems / pageSize)

  if (totalPages <= 1) {
    return null
  }

  const handlePageClick = (event: { selected: number }) => {
    onPageChange(event.selected)
  }

  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel="›"
      previousLabel="‹"
      onPageChange={handlePageClick}
      pageRangeDisplayed={3}
      marginPagesDisplayed={1}
      pageCount={totalPages}
      forcePage={currentPage}
      containerClassName="pagination-container"
      pageClassName="pagination-page"
      pageLinkClassName="pagination-link"
      activeClassName="pagination-active"
      previousClassName="pagination-nav"
      nextClassName="pagination-nav"
      previousLinkClassName="pagination-link"
      nextLinkClassName="pagination-link"
      breakClassName="pagination-break"
      disabledClassName="pagination-disabled"
    />
  )
}
